export class StringHelper {
  static capitalize(str) {
    if (!str || typeof str !== "string") {
      return "";
    }

    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  static toGuid(str) {
    if (!str || typeof str !== "string") {
      return "";
    }

    return str.replace(/([0-z]{8})([0-z]{4})([0-z]{4})([0-z]{4})([0-z]{12})/, "$1-$2-$3-$4-$5");
  }

  static cleanForTranslationTag(message) {
    const regex = /\$t\('(.*?)'\)/gi;

    const groups = regex.exec(message);
    if (groups[1]) {
      return groups[1];
    }

    return groups[0];
  }

  static convertNewLinesToHtmlBr(str) {
    if (!str || typeof str !== "string") {
      return "";
    }

    return str.replace(/(?:\r\n|\r|\n)/g, "<br />");
  }
}
